import { Menu } from "antd";
import clsx from "clsx";
import { connect } from "react-redux";

import styles from "./FlywheelMenu.module.scss";

import { filteredBook, flatBook, getCalculatedPrice } from "../../../lib/util";

import { bookTypes } from "../../../lib/constants";
import { currencyPairByIdSelector } from "../../../state/currency/currencyState";
import { OrderSide } from "../../../state/orders/types";
import { ClickType, getSettings } from "../../../state/settings/settingsState";

export const FlywheelItem = props => {
  const {
    instrumentId,
    clickType,
    actionOrder,
    item,
    itemObj,
    orderSide,
    quantity,
    longestLength,
    currencyPair,
    settings,
    ...allMenuItemNativeProps
  } = props;

  // We are removing the dispatch field from the native props because it's an invalid value on a <li> tag (Menu.Item generates a <li> tag)
  const { dispatch, ...menuItemNativeProps } = allMenuItemNativeProps;

  const isSweepable = currencyPair?.bookType === bookTypes.sweepable;

  const itemString = item.toString();
  const itemLength = itemString.length;

  // If the price is short -> we don't want to highlight the last number, we leave it as it is
  const isShort = itemLength < longestLength;

  const book = settings.marketSettings.enablePriceFiltering
    ? filteredBook(currencyPair.bids, currencyPair.asks, settings.marketSettings.depthDisplay, instrumentId, quantity)
    : flatBook(currencyPair.bids, currencyPair.asks, settings.marketSettings.depthDisplay, instrumentId);
  const topOfBook = book[0];

  const getFlywheelItemClassname = () => {
    let bidPrice = topOfBook?.bidPriceNum;
    let askPrice = topOfBook?.askPriceNum;

    if (isSweepable && Array.isArray(book) && book.length > 0 && quantity > 0) {
      bidPrice = getCalculatedPrice("bidSize", "bidPriceNum", book, quantity, instrumentId);
      askPrice = getCalculatedPrice("askSize", "askPriceNum", book, quantity, instrumentId);
    }

    if (orderSide === OrderSide.Buy) {
      if (item > askPrice) {
        return `${styles.highlightedItem} highlightedItem`;
      } else if (item < askPrice) {
        return `${styles.lowlightedItem} lowlightedItem`;
      }
    }

    if (orderSide === OrderSide.Sell) {
      if (item < bidPrice) {
        return `${styles.highlightedItem} highlightedItem`;
      } else if (item > bidPrice) {
        return `${styles.lowlightedItem} lowlightedItem`;
      }
    }

    return "";
  };

  return (
    <Menu.Item
      {...menuItemNativeProps}
      // disabled={readOnly}
      disabled={quantity === null || quantity === "" || quantity === 0}
      onClick={() => {
        if (clickType === ClickType.Single && quantity !== null && quantity !== "" && quantity != 0) {
          actionOrder(item, orderSide, quantity);
        }
      }}
      onDoubleClick={() => {
        if (clickType === ClickType.Double && quantity !== null && quantity !== "" && quantity != 0) {
          actionOrder(item, orderSide, quantity);
        }
      }}
      className={clsx(
        `${styles.flywheelMenuItem} flywheelMenuItem`,
        !itemObj?.varBig && styles.flywheelMenuItemNoHighlights
      )}
      key={itemString}
    >
      {isShort ? (
        // <span>{itemString}</span>
        <>
          <span className={clsx(styles.basePrice, !itemObj?.varBig && getFlywheelItemClassname())}>
            {itemObj.basePrice}
          </span>
          {itemObj?.varBig && (
            <div className={clsx(styles.specialNumbersContainer, getFlywheelItemClassname())}>
              <span className={`${styles.bigNumber} bigNumber`}>{itemObj.varBig}</span>
              <span className={`${styles.smallNumber} smallNumber`}>{itemObj.varSm}</span>
            </div>
          )}
        </>
      ) : (
        <>
          {/* <span>{itemString.slice(0, itemLength - 1)}</span>
          <span className={`${styles.smallNumber} smallNumber`}>{itemString.slice(itemLength - 1)}</span> */}
          <span className={clsx(styles.basePrice, !itemObj?.varBig && getFlywheelItemClassname())}>
            {itemObj.basePrice}
          </span>
          {itemObj?.varBig && (
            <div className={clsx(styles.specialNumbersContainer, getFlywheelItemClassname())}>
              <span className={`${styles.bigNumber} bigNumber`}>{itemObj.varBig}</span>
              <span className={`${styles.smallNumber} smallNumber`}>{itemObj.varSm}</span>
            </div>
          )}
        </>
      )}
    </Menu.Item>
  );
};

export default connect((state: any, ownProps: any) => {
  return {
    currencyPair: currencyPairByIdSelector(state, ownProps.instrumentId),
    settings: getSettings(state),
  };
})(FlywheelItem);
